<template>
    <div class="product-search-refinement" :class="{ 'product-search-refinement--expanded': expanded }">
        <div class="product-search-refinement__header">
            {{ title }}
            
            <!-- <svg stroke="currentColor" viewBox="0 0 24 24" @click="expanded = !expanded">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
            </svg> -->
        </div>

        <ais-refinement-list v-show="expanded" v-bind="params" :limit="100" searchable-placeholder="Search" :sort-by="['name:asc']" />
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },

        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            expanded: true
        }
    }
}
</script>
